const translation = {
    confirm: '¿Está seguro?',
    common: { back: 'Atrás' },
    save: 'Guardar',
    returnToGame: '¿Estás seguro de que quieres volver al juego?',
    yes: 'Sí',
    no: 'No',
    login: {
        auth: 'Autorización',
        noAcc: 'Sin cuenta',
        reg: 'Registro',
        mail: 'Iniciar sesión por correo electrónico',
        registration: 'Registro',
        agreement: 'Al hacer clic en el botón "Registrarse", confirma su',
        agreementLink: 'consentimiento para el procesamiento de datos personales.',
        submit: 'Registro',
        continue: 'Continuar',
        emailLabel: 'Correo electrónico',
        passwordLabel: 'Contraseña',
        repeatPasswordLabel: 'Repita la contraseña',
        loginButton: 'Acceso',
        logout: 'Cerrar sesión',
        invalidEmail: 'Formato de correo inválido',
        invalidFormatPassword: 'Formato de contraseña incorrecto',
        forgotPassword: 'Olvidaste tu contraseña',
        passwordRecovery: 'Recuperación de contraseña',
        passwordRecoveryTitle: 'Le enviaremos una carta al correo electrónico especificado.',
        sendLetter: 'Enviar carta',
        userExists: 'El usuario con este correo electrónico existe',
        userNotExists: 'El usuario con este correo electrónico no existe',
        passwordResetToMail: 'Las instrucciones para restablecer su contraseña se han enviado por correo electrónico',
        passwordValidation: 'Debe contener de 8 a 20 letras o números latinos',
        invalidPassword: 'Contraseña incorrecta',
        sessionNotFound: 'Sesión no encontrada',
        mismatchPassword: '¡Contraseña no coincide! Intentar otra vez',
        rememberPassword: 'Recordaste tu contraseña',
        restore: 'Restaurar',
        accExist: 'Tener una cuenta',
        confirmationCode: 'Introduce el código de confirmación enviado por correo electrónico',
        code: 'Código de confirmación',
        send: 'Enviar',
        confirmation: 'Confirmar',
        resend: 'Reenviar',
        codeIsValid: 'El código es válido',
        codeNotValid: 'El código no es válido',
        newPassword: 'Introduzca una nueva contraseña',
        passwordUsedBefore: 'La contraseña ya se ha utilizado antes',
        passwordUpdatedSuccessfully: 'Contraseña actualizada exitosamente',
        enterEmail: 'Introduce tu dirección de correo electrónico',
        enterPassword: 'Introducir la contraseña',
        enterPasswordAgain: 'Ingrese su contraseña nuevamente',
        enterAgreement: 'Confirme su consentimiento para el tratamiento de datos personales',
        notRobot: 'Demuestra que no eres un robot',
        deletionPersonalData: 'Para eliminar datos personales, envíenos un mensaje por correo electrónico.',
    },
    profile: {
        edit: 'Editar perfil',
        remove: 'Borrar cuenta',
        projectName: 'Nombre del proyecto',
        editing: 'Editando tu perfil',
        name: 'Su nombre',
        lastName: 'Tu apellido',
        inputPattern: 'De dos a diez letras',
        purchases: 'No hay compras',
        settings: 'Configuración',
        transactions: 'Transacciones',
    },
    payment: {
        toPay: 'pagar',
        method: 'Método de pago',
        pay: 'Pagar',
        purchases: 'Compras',
        paymentMethod: 'Método de pago',
        debitCard: 'Tarjeta de débito',
        copy: '¡Identificación de pago copiada!',
        cancellation: '¿Estás seguro de que deseas cancelar el pago?',
        email: 'Correo electrónico para recibir un recibo',
        status: {
            none: 'Ninguno',
            pending: 'Pendiente',
            paid: 'Pagado',
            fail: 'Fallido',
        },
        state: {
            progress: 'El pago está siendo procesado',
            wait: 'Por favor, espera',
            paid: 'Pagado',
            successful: 'Pago exitoso',
            notPaid: 'No pagado',
            error: 'Error',
            cancelled: 'Pago cancelado',
            cancel: 'Cancelar',
        },
    },
    games: {
        header: {
            buttonGuest: 'Invitado',
            buttonLogin: 'Iniciar sesión',
            buttonLogout: 'Cerrar sesión',
        },
        buttonPlay: 'Jugar',
        buttonInDevelop: 'En desarrollo',
    },
    support: {
        noPurchases: 'Aún no tienes compras',
        contactSupport: 'Contactar soporte',
        paymentId: 'ID de pago',
        userId: 'ID de usuario',
        requestReason: 'Motivo de contacto',
        feedbackEmail: 'Correo para respuesta',
        dropNotCredited: 'Drop no acreditado',
        other: 'Otro',
        success: 'Solicitud aceptada',
        successText: 'Hemos recibido su solicitud y nos pondremos en contacto con usted por correo electrónico en breve',
    },
    receipt: {
        generation: 'Generando recibo',
        wait: 'Esto puede tardar un poco, por favor espere.'
    },
}

export default {
    translation,
}
